import { format } from 'date-fns'
import { getToday } from '../../../libs/date'

import { useUserContext } from '../../../auth/UserProvider'
import { useShippingSendMutation } from '../../../services/shippingSend'

const formatSubmitData = (values, auditData) => {
  const {
    centerCode,
    packagesNumber,
    origin,
    destination,
    serviceType,
    referenceNumber,
    weight,
  } = values

  const optionalFields = {}
  if (Boolean(origin.email))
    optionalFields.sender_email_notify_address = origin.email

  if (Boolean(origin.phone)) optionalFields.sender_phones = [origin.phone]

  if (Boolean(destination.email))
    optionalFields.recipient_email_notify_address = destination.email

  if (Boolean(destination.phone))
    optionalFields.recipient_phones = [destination.phone]

  if (Boolean(referenceNumber))
    optionalFields.client_references = [referenceNumber]

  // pickup
  const pickup = { comments: '' }
  const minDate = new Date(values.pickup.split('/')[0])
  const maxDate = new Date(values.pickup.split('/')[1])
  pickup.date = values.pickup ? format(minDate, 'yyyy-MM-dd') : ''
  pickup.time = [
    {
      min_hourminute: format(minDate, 'HH:mm'),
      max_hourminute: format(maxDate, 'HH:mm'),
    },
  ]

  return {
    ...optionalFields,
    client_center_code: centerCode,
    pickup,
    recipient_name: destination.name,
    recipient_address: destination.address,
    recipient_address_2: destination.city,
    recipient_country_code: destination.country,
    recipient_postal_code: destination.postalCode.postalCode,
    sender_address: origin.address,
    sender_address_2: origin.city,
    sender_name: origin.name,
    sender_postal_code: origin.postalCode.postalCode,
    shipping_type_code: serviceType.originalCode,
    item_count: Number(packagesNumber),
    shipping_weight_declared: Number(weight),
    audit: auditData,
    shipping_date: getToday(),
  }
}

const useShippingSendMobile = updateServerError => {
  const { auditData } = useUserContext()

  const submitMutation = useShippingSendMutation({
    useErrorBoundary: false,
    onError: error => {
      const errorTextKey =
        error.error_code === 500 ? ['error:network'] : ['error:general']
      updateServerError(errorTextKey)
    },
    onSuccess: response => {
      const newShippingCode = response.data.shipping_code

      return Promise.resolve(newShippingCode)

      // history.push(routes.HOME.linkTo(), { newShippingCode })
    },
  })

  const submitForm = async values => {
    const formattedData = formatSubmitData(values, auditData)
    const newShipping = await submitMutation.mutateAsync(formattedData)
    const newShippingCode = newShipping.data.shipping_code

    return Promise.resolve(newShippingCode)
  }
  return { submitForm, isSubmitting: submitMutation.isLoading }
}

export default useShippingSendMobile
